/* eslint-disable no-magic-numbers */
import React from 'react';
import { useIntl } from 'react-intl';

import { useReportBuilderContext } from '../../report-builder.context';
import { DataField } from '../../types';
import { getConsolidationShortCode } from '../../utils-data';
import { useConsolidatedForecastingContext } from '../../../forecast/detail/context/consolidated-forecasting-context';
import styles from './map-template-data-modal.scss';
import { FilterableSelect, Option } from 'carbon-react/lib/components/select';

interface Props {
  value: string;
  onChange: (v: string) => void;
  defaultText?: string;
  isFormula?: boolean;
}

export const AllFieldsSelectDropdown = ({ value, onChange, defaultText, isFormula }: Props) => {
  const intl = useIntl();
  const { allFinFieldsArray, rowFormulaData } = useReportBuilderContext();
  const { consolidation } = useConsolidatedForecastingContext();

  return (
    <div className={styles.AllFieldsSelectDropdown}>
      <FilterableSelect
        id="all-fields-select-dropdown"
        value={value || ''}
        onChange={e => onChange(e.target.value as string)}
        placeholder={defaultText || intl.formatMessage({ id: 'common.search_here', defaultMessage: 'Search here' })}
      >
        <Option value="" text="" />
        {(isFormula ? ((rowFormulaData as unknown) as DataField[]) : allFinFieldsArray).map((option, i) => (
          <Option
            data-role={`option-depth-${option.depth}`}
            key={`${option.name}-${i}`}
            value={option.ref}
            text={`${option.name} ${
              consolidation && option.organisation_id
                ? `- ${getConsolidationShortCode(consolidation, option.organisation_id)}`
                : ''
            }`}
          />
        ))}
      </FilterableSelect>
    </div>
  );
};
